export const wordsList = [
  {
    value: '您好，请问在找工作吗？',
  },
  {
    value: '您好，在吗？',
  },
  {
    value: 'HI，优质岗位大量招人，期待您的简历',
  }
];
